import { render, staticRenderFns } from "./signature.view.vue?vue&type=template&id=2c808c3c&scoped=true"
import script from "./signature.view.vue?vue&type=script&lang=js"
export * from "./signature.view.vue?vue&type=script&lang=js"
import style0 from "./signature.view.vue?vue&type=style&index=0&id=2c808c3c&prod&lang=scss"
import style1 from "./signature.view.vue?vue&type=style&index=1&id=2c808c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c808c3c",
  null
  
)

export default component.exports